<template>
		<div class="j-main">
			<div data-v-f4ffdb53="" class="tabbar-layout router j-container h5">
				<div data-v-f4ffdb53="" class="j-main">
					<div data-v-f4ffdb53="" class="move-tip-group-overlay van-overlay" style="display: none;">
						<div data-v-f4ffdb53="" class="move-tip-group"><span data-v-f4ffdb53="">我知道了</span><img
								data-v-f4ffdb53=""
								src="https://cdn-common.jianyu360.cn/jy_mobile/assets/movingReminder-73301479.png"
								alt="百宝箱已升级为工作台"></div>
					</div>
					<div data-v-32d49ee2="" data-v-f4ffdb53="" class="home app-header-top" ref="scrollContainer" @scroll="handleScroll">
						<div data-v-32d49ee2="" class="header-exposure"></div>
						<h5 data-v-32d49ee2="" class="logo-title tabbar-header">
							<div data-v-32d49ee2="" class="logo-img-container">
								<img data-v-32d49ee2="" src="/logo.png" alt="">
							</div>
						</h5>
						<div data-v-32d49ee2="" class="">
							<div  ref="stickyElement" :class="['van-sticky', { 'van-sticky--fixed': isFixed }]">
								<div data-v-32d49ee2="" class="search-box app-header-top">
									<div data-v-32d49ee2="" class="search clickable" @click="goToSearch"><i data-v-991cf48f=""
											data-v-32d49ee2="" class="iconfont icon-search"></i><span
											data-v-32d49ee2="">找项目 搜采购 拓客户 查企业</span></div>
								</div>
							</div>
						</div>
						<div data-v-39861154="" data-v-32d49ee2="" class="hot-key-container hot-key-wrapper"><span
								data-v-39861154="" class="hot-key-hd"><span data-v-39861154=""
									class="hot-key-icon"></span></span>
							<div data-v-39861154="" class="hot-key-bd hot-key-list"><span data-v-39861154=""
									class="hot-key-item clickable">信息化 </span><span data-v-39861154=""
									class="hot-key-item clickable">软件 </span><span data-v-39861154=""
									class="hot-key-item clickable">网络 </span><span data-v-39861154=""
									class="hot-key-item clickable">网络安全 </span><span data-v-39861154=""
									class="hot-key-item clickable">监控 </span><span data-v-39861154=""
									class="hot-key-item clickable">安防 </span></div>
									<!--
									<span data-v-39861154="" class="hot-key-ft">
										<span data-v-39861154="" class="j-icon j-base-icon icon-update-white clickable"></span>
									</span>-->
						</div>
						<div data-v-32d49ee2="" class="home-content-container">
							<div data-v-e25e2be5="" data-v-32d49ee2="" class="my-swipe-floor swipe-floor">
								<div data-v-e25e2be5="" class="my-swipe-floor-skeleton" style="display: none;">
									<div data-v-e25e2be5="" class="van-skeleton van-skeleton--animate">
										<div data-v-e25e2be5=""
											class="van-skeleton__avatar van-skeleton__avatar--round"></div>
										<div data-v-e25e2be5="" class="van-skeleton__content">
											<h3 data-v-e25e2be5="" class="van-skeleton__title"></h3>
										</div>
									</div>
									<div data-v-e25e2be5="" class="van-skeleton van-skeleton--animate">
										<div data-v-e25e2be5=""
											class="van-skeleton__avatar van-skeleton__avatar--round"></div>
										<div data-v-e25e2be5="" class="van-skeleton__content">
											<h3 data-v-e25e2be5="" class="van-skeleton__title"></h3>
										</div>
									</div>
									<div data-v-e25e2be5="" class="van-skeleton van-skeleton--animate">
										<div data-v-e25e2be5=""
											class="van-skeleton__avatar van-skeleton__avatar--round"></div>
										<div data-v-e25e2be5="" class="van-skeleton__content">
											<h3 data-v-e25e2be5="" class="van-skeleton__title"></h3>
										</div>
									</div>
									<div data-v-e25e2be5="" class="van-skeleton van-skeleton--animate">
										<div data-v-e25e2be5=""
											class="van-skeleton__avatar van-skeleton__avatar--round"></div>
										<div data-v-e25e2be5="" class="van-skeleton__content">
											<h3 data-v-e25e2be5="" class="van-skeleton__title"></h3>
										</div>
									</div>
									<div data-v-e25e2be5="" class="van-skeleton van-skeleton--animate">
										<div data-v-e25e2be5=""
											class="van-skeleton__avatar van-skeleton__avatar--round"></div>
										<div data-v-e25e2be5="" class="van-skeleton__content">
											<h3 data-v-e25e2be5="" class="van-skeleton__title"></h3>
										</div>
									</div>
									<div data-v-e25e2be5="" class="van-skeleton van-skeleton--animate">
										<div data-v-e25e2be5=""
											class="van-skeleton__avatar van-skeleton__avatar--round"></div>
										<div data-v-e25e2be5="" class="van-skeleton__content">
											<h3 data-v-e25e2be5="" class="van-skeleton__title"></h3>
										</div>
									</div>
									<div data-v-e25e2be5="" class="van-skeleton van-skeleton--animate">
										<div data-v-e25e2be5=""
											class="van-skeleton__avatar van-skeleton__avatar--round"></div>
										<div data-v-e25e2be5="" class="van-skeleton__content">
											<h3 data-v-e25e2be5="" class="van-skeleton__title"></h3>
										</div>
									</div>
									<div data-v-e25e2be5="" class="van-skeleton van-skeleton--animate">
										<div data-v-e25e2be5=""
											class="van-skeleton__avatar van-skeleton__avatar--round"></div>
										<div data-v-e25e2be5="" class="van-skeleton__content">
											<h3 data-v-e25e2be5="" class="van-skeleton__title"></h3>
										</div>
									</div>
									<div data-v-e25e2be5="" class="van-skeleton van-skeleton--animate">
										<div data-v-e25e2be5=""
											class="van-skeleton__avatar van-skeleton__avatar--round"></div>
										<div data-v-e25e2be5="" class="van-skeleton__content">
											<h3 data-v-e25e2be5="" class="van-skeleton__title"></h3>
										</div>
									</div>
									<div data-v-e25e2be5="" class="van-skeleton van-skeleton--animate">
										<div data-v-e25e2be5=""
											class="van-skeleton__avatar van-skeleton__avatar--round"></div>
										<div data-v-e25e2be5="" class="van-skeleton__content">
											<h3 data-v-e25e2be5="" class="van-skeleton__title"></h3>
										</div>
									</div>
								</div>
						
							</div>
					
							<div data-v-261b786e="" data-v-32d49ee2="" class="home-list">
								<div data-v-261b786e=""
									class="flex flex-items-center van-hairline--bottom home-list-header">
									<h3 data-v-261b786e="" class="header-title">商机推荐</h3>
									<!--<div data-v-261b786e="" class="flex flex-items-center header-value"><span
											data-v-261b786e="" class="header-desc">完善信息，推荐更准</span><span
											data-v-261b786e="" class="flex flex-items-center header-set">去设置 <i
												data-v-261b786e="" class="van-icon van-icon-arrow"
												style="color: rgb(42, 190, 209);"></i></span></div>-->
								</div>
								<div data-v-261b786e="" class="list"><!---->
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">关于记事本的网上超市合同公告</span><!----></div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item title-file main">有附件</span><span
													data-v-06a7ce78="" class="tag-item grey">通化市</span><span
													data-v-06a7ce78="" class="tag-item grey">医疗</span><span
													data-v-06a7ce78="" class="tag-item grey">合同</span><span
													data-v-06a7ce78="" class="tag-item grey">4882元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell visited">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">【甘肃】平凉第二核心机楼土建建设项目检测服务（消防检测）成交候选人公示</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">平凉市</span><span
													data-v-06a7ce78="" class="tag-item grey">电信行业</span><span
													data-v-06a7ce78="" class="tag-item grey">中标</span><span
													data-v-06a7ce78="" class="tag-item grey">2.24万元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">关于平板电脑/MID的网上超市合同公告</span><!----></div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">萍乡市</span><span
													data-v-06a7ce78="" class="tag-item grey">自然资源</span><span
													data-v-06a7ce78="" class="tag-item grey">合同</span><span
													data-v-06a7ce78="" class="tag-item grey">3299元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">关于宣传品制作服务的服务工程合同公告</span><!----></div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item title-file main">有附件</span><span
													data-v-06a7ce78="" class="tag-item grey">抚州市</span><span
													data-v-06a7ce78="" class="tag-item grey">学校</span><span
													data-v-06a7ce78="" class="tag-item grey">合同</span><span
													data-v-06a7ce78="" class="tag-item grey">9737元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">关于办公设备维修和保养服务的服务工程合同公告</span><!----></div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">吉安市</span><span
													data-v-06a7ce78="" class="tag-item grey">公安</span><span
													data-v-06a7ce78="" class="tag-item grey">合同</span><span
													data-v-06a7ce78="" class="tag-item grey">1010元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">上海华能电商物流服务运力采购第1002期（第二次）询价书的采购结果</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">上海市</span><span
													data-v-06a7ce78="" class="tag-item grey">成交</span><span
													data-v-06a7ce78="" class="tag-item grey">4622元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">上海华能电商物流服务运力采购第994期询价书的采购结果</span><!----></div>
											<!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">上海市</span><span
													data-v-06a7ce78="" class="tag-item grey">成交</span><span
													data-v-06a7ce78="" class="tag-item grey">1.59万元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">上海华能电商物流服务运力采购第1001期询价书的采购结果</span><!----></div>
											<!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">上海市</span><span
													data-v-06a7ce78="" class="tag-item grey">成交</span><span
													data-v-06a7ce78="" class="tag-item grey">5800元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">青岛市即墨区德馨小学其他印刷服务项目</span><!----></div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item title-file main">有附件</span><span
													data-v-06a7ce78="" class="tag-item grey">青岛市</span><span
													data-v-06a7ce78="" class="tag-item grey">学校</span><span
													data-v-06a7ce78="" class="tag-item grey">验收</span><span
													data-v-06a7ce78="" class="tag-item grey">15.16万元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">青岛市即墨区德馨小学车辆保险服务</span><!----></div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item title-file main">有附件</span><span
													data-v-06a7ce78="" class="tag-item grey">青岛市</span><span
													data-v-06a7ce78="" class="tag-item grey">验收</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">中国铁路郑州局集团有限公司长治铁路物流中心晋城北营业部职工厕所整修工程项目成交候选人公示</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">山西</span><span
													data-v-06a7ce78="" class="tag-item grey">交通</span><span
													data-v-06a7ce78="" class="tag-item grey">中标</span><span
													data-v-06a7ce78="" class="tag-item grey">4.43万元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">上海局集团公司南京东机辆段2025年铁路机务管理信息系统运维技术服务委外项目采购方式公示</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">南京市</span><span
													data-v-06a7ce78="" class="tag-item grey">单一</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">广州大型养路机械运用检修段关于2025年电梯检修保养的项目公告</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">广州市</span><span
													data-v-06a7ce78="" class="tag-item grey">竞价</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">铁道党校2025-2026年洗涤服务项目成交公告</span><!----></div>
											<!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">北京市</span><span
													data-v-06a7ce78="" class="tag-item grey">党委办</span><span
													data-v-06a7ce78="" class="tag-item grey">成交</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">五矿二十三冶红城湖新建一所九年一贯制学校（新建）项目室外园建及绿化工程专业分包招标中标候选人公示</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">南昌市</span><span
													data-v-06a7ce78="" class="tag-item grey">学校</span><span
													data-v-06a7ce78="" class="tag-item grey">中标</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">古浪县2025年高标准农田建设项目勘察设计（招标代理服务）招标公告</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item title-file main">有附件</span><span
													data-v-06a7ce78="" class="tag-item grey">武威市</span><span
													data-v-06a7ce78="" class="tag-item grey">农业</span><span
													data-v-06a7ce78="" class="tag-item grey">招标</span><span
													data-v-06a7ce78="" class="tag-item grey">5万元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">台式电脑采购</span><!----></div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">贵阳市</span><span
													data-v-06a7ce78="" class="tag-item grey">学校</span><span
													data-v-06a7ce78="" class="tag-item grey">其它</span><span
													data-v-06a7ce78="" class="tag-item grey">2万元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">230山东高速建设发展有限公司水泥材料竞争性谈判采购项目公告</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">青岛市</span><span
													data-v-06a7ce78="" class="tag-item grey">建筑业</span><span
													data-v-06a7ce78="" class="tag-item grey">竞谈</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">聊城市彭楼灌区基层站所运行管理设施采购及简易维修项目招标代理机构选取成交公示</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">聊城市</span><span
													data-v-06a7ce78="" class="tag-item grey">成交</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">清水县永清镇卫生院清水县永清镇卫生院采购印刷品</span><!----></div>
											<!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item title-file main">有附件</span><span
													data-v-06a7ce78="" class="tag-item grey">天水市</span><span
													data-v-06a7ce78="" class="tag-item grey">医疗</span><span
													data-v-06a7ce78="" class="tag-item grey">合同</span><span
													data-v-06a7ce78="" class="tag-item grey">1.53万元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">明光市殡仪馆关于电源的网上超市采购项目合同履约验收公告</span><!----></div>
											<!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">滁州市</span><span
													data-v-06a7ce78="" class="tag-item grey">民政</span><span
													data-v-06a7ce78="" class="tag-item grey">验收</span><span
													data-v-06a7ce78="" class="tag-item grey">1232元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">合肥市科学技术局关于装订机的网上超市采购项目合同履约验收公告</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">合肥市</span><span
													data-v-06a7ce78="" class="tag-item grey">科技</span><span
													data-v-06a7ce78="" class="tag-item grey">验收</span><span
													data-v-06a7ce78="" class="tag-item grey">2680元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">芜湖市公安局镜湖分局关于键鼠套装的网上超市采购项目合同履约验收公告</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">芜湖市</span><span
													data-v-06a7ce78="" class="tag-item grey">公安</span><span
													data-v-06a7ce78="" class="tag-item grey">验收</span><span
													data-v-06a7ce78="" class="tag-item grey">4935元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">天长中学关于炊事设备的网上超市采购项目合同履约验收公告</span><!----></div>
											<!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">滁州市</span><span
													data-v-06a7ce78="" class="tag-item grey">学校</span><span
													data-v-06a7ce78="" class="tag-item grey">验收</span><span
													data-v-06a7ce78="" class="tag-item grey">4.51万元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">淮南市职业教育中心关于中性笔的网上超市采购项目合同履约验收公告</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">淮南市</span><span
													data-v-06a7ce78="" class="tag-item grey">教育</span><span
													data-v-06a7ce78="" class="tag-item grey">验收</span><span
													data-v-06a7ce78="" class="tag-item grey">6894元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">合肥市望湖中学关于图形图像输入设备的网上超市采购项目合同履约验收公告</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">合肥市</span><span
													data-v-06a7ce78="" class="tag-item grey">学校</span><span
													data-v-06a7ce78="" class="tag-item grey">验收</span><span
													data-v-06a7ce78="" class="tag-item grey">6.9万元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">亳州十二中学关于卡套/证件套的网上超市采购项目合同履约验收公告</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">亳州市</span><span
													data-v-06a7ce78="" class="tag-item grey">学校</span><span
													data-v-06a7ce78="" class="tag-item grey">验收</span><span
													data-v-06a7ce78="" class="tag-item grey">4450元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">中共铜陵市铜官区委社会工作部关于办公桌的网上超市采购项目合同履约验收公告</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">铜陵市</span><span
													data-v-06a7ce78="" class="tag-item grey">党委办</span><span
													data-v-06a7ce78="" class="tag-item grey">验收</span><span
													data-v-06a7ce78="" class="tag-item grey">1600元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">亳州市消防救援支队关于摄像机配件的网上超市采购项目合同履约验收公告</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">亳州市</span><span
													data-v-06a7ce78="" class="tag-item grey">应急管理</span><span
													data-v-06a7ce78="" class="tag-item grey">验收</span><span
													data-v-06a7ce78="" class="tag-item grey">4.89万元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">亳州学院关于移动硬盘的网上超市采购项目合同履约验收公告</span><!----></div>
											<!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">亳州市</span><span
													data-v-06a7ce78="" class="tag-item grey">学校</span><span
													data-v-06a7ce78="" class="tag-item grey">验收</span><span
													data-v-06a7ce78="" class="tag-item grey">1829元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">龙化-本部、能源-江沙-2025-2028-长协询价通知</span><!----></div>
											<!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item title-file main">有附件</span><span
													data-v-06a7ce78="" class="tag-item grey">黑龙江</span><span
													data-v-06a7ce78="" class="tag-item grey">能源化工</span><span
													data-v-06a7ce78="" class="tag-item grey">询价</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">BIM技术应用综合平台GIS引擎升级及扩容项目采购公告</span><!----></div>
											<!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">深圳市</span><span
													data-v-06a7ce78="" class="tag-item grey">建筑业</span><span
													data-v-06a7ce78="" class="tag-item grey">招标</span><span
													data-v-06a7ce78="" class="tag-item grey">150万元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">金沙县中心血库关于打印/复印纸的网上超市采购项目合同履约验收公告</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">毕节市</span><span
													data-v-06a7ce78="" class="tag-item grey">验收</span><span
													data-v-06a7ce78="" class="tag-item grey">180元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">竞争性谈判采购汽运供应商-气垫箱车-竞争性谈判公告</span><!----></div>
											<!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">北京市</span><span
													data-v-06a7ce78="" class="tag-item grey">运输物流</span><span
													data-v-06a7ce78="" class="tag-item grey">竞谈</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">华能白杨河电厂2024W05-094潜水泵、皮带等比价采购变更询比采购公告</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">淄博市</span><span
													data-v-06a7ce78="" class="tag-item grey">能源化工</span><span
													data-v-06a7ce78="" class="tag-item grey">询价</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">罗芳水质净化厂曝气循环阀气动执行器维修备件采购项目结果公告</span><!----></div>
											<!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">深圳市</span><span
													data-v-06a7ce78="" class="tag-item grey">水利</span><span
													data-v-06a7ce78="" class="tag-item grey">成交</span><span
													data-v-06a7ce78="" class="tag-item grey">35.6万元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">泰开电力开关--运输24075次竞价竞价公告</span><!----></div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">泰安市</span><span
													data-v-06a7ce78="" class="tag-item grey">竞价</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">打印机复印机维修采购项目竞价成交公告</span><!----></div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">吐鲁番市</span><span
													data-v-06a7ce78="" class="tag-item grey">学校</span><span
													data-v-06a7ce78="" class="tag-item grey">成交</span><span
													data-v-06a7ce78="" class="tag-item grey">1.3万元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">分谈分签-面板等</span><!----></div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">上海市</span><span
													data-v-06a7ce78="" class="tag-item grey">制造业</span><span
													data-v-06a7ce78="" class="tag-item grey">询价</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">关于房屋修缮的服务工程合同公告</span><!----></div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item title-file main">有附件</span><span
													data-v-06a7ce78="" class="tag-item grey">上饶市</span><span
													data-v-06a7ce78="" class="tag-item grey">学校</span><span
													data-v-06a7ce78="" class="tag-item grey">合同</span><span
													data-v-06a7ce78="" class="tag-item grey">2.93万元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">滨绥铁路K491+213～K496+247段改造工程甲供物资宽轨道岔</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">哈尔滨市</span><span
													data-v-06a7ce78="" class="tag-item grey">交通</span><span
													data-v-06a7ce78="" class="tag-item grey">其它</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">关于板架的网上超市合同公告</span><!----></div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item title-file main">有附件</span><span
													data-v-06a7ce78="" class="tag-item grey">合肥市</span><span
													data-v-06a7ce78="" class="tag-item grey">学校</span><span
													data-v-06a7ce78="" class="tag-item grey">合同</span><span
													data-v-06a7ce78="" class="tag-item grey">2.8万元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">关于卡套/证件套的网上超市合同公告</span><!----></div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item title-file main">有附件</span><span
													data-v-06a7ce78="" class="tag-item grey">亳州市</span><span
													data-v-06a7ce78="" class="tag-item grey">学校</span><span
													data-v-06a7ce78="" class="tag-item grey">合同</span><span
													data-v-06a7ce78="" class="tag-item grey">4450元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">关于烟机灶具配件的网上超市合同公告</span><!----></div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item title-file main">有附件</span><span
													data-v-06a7ce78="" class="tag-item grey">滁州市</span><span
													data-v-06a7ce78="" class="tag-item grey">学校</span><span
													data-v-06a7ce78="" class="tag-item grey">合同</span><span
													data-v-06a7ce78="" class="tag-item grey">1.1万元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">关于抽纸的网上超市合同公告</span><!----></div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item title-file main">有附件</span><span
													data-v-06a7ce78="" class="tag-item grey">蚌埠市</span><span
													data-v-06a7ce78="" class="tag-item grey">统计</span><span
													data-v-06a7ce78="" class="tag-item grey">合同</span><span
													data-v-06a7ce78="" class="tag-item grey">1.05万元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">南湖南路片区管理委员会关于藕粉/麦片/冲饮品的网上超市采购项目成交公告</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">乌鲁木齐市</span><span
													data-v-06a7ce78="" class="tag-item grey">政府办</span><span
													data-v-06a7ce78="" class="tag-item grey">成交</span><span
													data-v-06a7ce78="" class="tag-item grey">450元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">关于防水工程的服务工程合同公告</span><!----></div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item title-file main">有附件</span><span
													data-v-06a7ce78="" class="tag-item grey">赣州市</span><span
													data-v-06a7ce78="" class="tag-item grey">城管</span><span
													data-v-06a7ce78="" class="tag-item grey">合同</span><span
													data-v-06a7ce78="" class="tag-item grey">1.88万元</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">合肥城建工程有限公司零星材料采购计划（气动三通等）-06询价单</span><!---->
											</div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">北京市</span><span
													data-v-06a7ce78="" class="tag-item grey">建筑业</span><span
													data-v-06a7ce78="" class="tag-item grey">预告</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">厦门综合航空培训基地项目零星材料询价采购评标结果公示</span><!----></div>
											<!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">北京市</span><span
													data-v-06a7ce78="" class="tag-item grey">中标</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<section data-v-06a7ce78="" data-v-261b786e=""
										class="project-cell cell-clickable right-bottom colorful-cell">
										<div data-v-06a7ce78="" class="title-group">
											<div data-v-06a7ce78="" class="title van-multi-ellipsis--l5"><!----><span
													data-v-06a7ce78="">胶带采购计划24121询价单</span><!----></div><!---->
										</div>
										<div data-v-06a7ce78="" class="info-group">
											<div data-v-06a7ce78="" class="tag-group"><!----><!----><!----><!----><span
													data-v-06a7ce78="" class="tag-item grey">北京市</span><span
													data-v-06a7ce78="" class="tag-item grey">预告</span></div>
										</div><!---->
										<div data-v-06a7ce78="" class="more-detail detail-list" style="display: none;">
										</div>
										<div data-v-06a7ce78="" class="footer-container"><span data-v-06a7ce78=""
												class="tag-item--time">2024-12-01</span>
											<div data-v-06a7ce78="" class="title-icon">
												<div data-v-261b786e="" data-v-06a7ce78="" class="right-event"><svg
														data-v-991cf48f="" data-v-261b786e="" aria-hidden="true"
														class="svg-icon icon-shoucang_weishoucang" data-v-06a7ce78=""
														style="font-size: 18px; margin-right: 4px;">
														<use data-v-991cf48f="" xlink:href="#icon-shoucang_weishoucang">
														</use>
													</svg><span data-v-261b786e="" data-v-06a7ce78=""
														class="label-icon">收藏</span></div>
											</div>
										</div>
									</section>
									<div data-v-261b786e=""></div>
								</div>
								<!--<div data-v-261b786e="" class="list-tips">
									<div data-v-261b786e="" class="tip-item">
										<p data-v-261b786e="">立即使用超级订阅，商机获取能力提升30倍。</p><button data-v-261b786e=""
											class="van-button van-button--confirm van-button--mini">
											<div data-v-261b786e="" class="van-button__content"><span data-v-261b786e=""
													class="van-button__text">了解详情</span></div>
										</button>
									</div>
								</div>-->
							</div>
						</div>
						<div data-v-d282f6b2="" data-v-32d49ee2="" class="customer-corner fadeOutRight"
							style="bottom: 16%;">
							<div data-v-d282f6b2="" class="content"><img data-v-d282f6b2=""
									src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAP4SURBVHgB7ZldThsxEIBnDC0tqoAjpG+EIsGeoAm0lXiDEwAnAE4AnIBwAsIJoE994Cdwgt20FVD1ge0NUKUiCo3dmf1pkmWdeDeu2of9pEjBsT0ztsczYwAKCgoK/iUIligduBPPXsAsIiyiEK+5iT4T0c83CpSHCnyl1PvLN84hWGJgAwLFx8SaQFiHtsI9UQA+KnUm79X21YLjwwAMZED5yF3HIbEJhoonYUOkkrtf5p0a5CSXAbzqo2NDO4BqBWygVP1WqA2/6txARjIbwMo/HxcNGjibMtkNrej+sICzBwDvqhoej8mGWxqmoS0lVqhP7B9JvFuU1axGZDagfNp0k8qz4krB7q2QNRMFyid09DD16HkXczMOZCCTAeWT5g6GztolVKJcilfbFN4VoUQDErtBC1G7nJ/ZMJzG3IDyscvX40GiOde2x8w23In70IiuHZUtWb1665yZzCHAFCF2Ei0+r3xe5RmPxj6lBeC5OtvpZtsznMLMgMkTl52v1NlGylezHps02AjRkqudbSyLZZqMNzJAoFjrakCs21A+5jMdF4oJ+90icNlkbF8DJj+4JUieUWhtg2UUyq3OvxGwwo7eb1xPA/jOxyewlWj24Q7sE87Z5U8oh3aiBdSivYV4II4EAauU/I1TAPWTfGDBzjEaRJZ2B8QIHmB6xAycjAWCJXTKt2Wh9lZKNWD6yK3Q0FnoJZRviqDfYATxRaN8Wxb5g0ZWqgEtAT2V/zNYQAUGhCK7qaxSanvqpDnT479MKa3RPBL/pxQGxEydfNqcOm0qzlh1fcqnXqNfn6zY24EoknK6nXZjhPkUVuI+YIlhsAQpR/mMqvB3MSQOSOGNu+8QvD50FP1RZ6yDJXQG+JCRFrZWqUBxIbzBJigB3Bsdh7QA5OfJpVQizYhJPUJCmhlA1ZMXfw+y01+Pc/sEfjINJ1lnYCJLtGV1os2FXp1+bMRHQqcM1a8vk42cQaKERYG4ogBnQiGqqRQe6mpmcuxr6BWNkWrlanqtrPWB6Eg8qllj5WVYST0iWt1a9DGC5+opC+SSbqz2FmJFeOKo0PC5LXx9kLu2qrFOWUrKrkKeZdHB36aa2+kly9rbaEyQGj8BejbB8ce/qm/yHurJ1JivXb65oJ3C+KaLZNWAyePmMiVd9T7dbh7I2b++c7zgkWxMbCbigp9lh60ZwCsvRsS1YXd6wYNayoOwn/V4WovE+BQWM3SnOBGUqp3Kn+fxLYuROF8KHr6nwja9xuV6obZmAEfKjOfxHJU8/EE+48/lfxyz5gPRMyGnEiWD7qlBMA/WfIBf2CT2TSWYc10QzIP1OMBMN9yK1PwP4KLqeFBQUFAQ8xtYzqqOaFnbawAAAABJRU5ErkJggg=="
									alt="">
								<p data-v-d282f6b2="">客服</p>
							</div>
						</div>
						<div data-v-989d00b0="" data-v-32d49ee2="" class="customer-bid fadeOutRight"
							style="bottom: 19%; display: none;">
							<div data-v-989d00b0="" class="content"><img data-v-989d00b0=""
									src="https://cdn-common.jianyu360.cn/jy_mobile/assets/customer-bid-f9103c5f.png"
									alt=""></div>
						</div><!----><!---->
						<div data-v-32d49ee2="" class="check-user-dialog">
							<div class="check-power-and-switch"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		

</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router'; 
export default {
	name: 'HomePage',
	props: {
		msg: String
	},
	setup() {
		
		const scrollContainer = ref(null);
		const isFixed = ref(false);  // 是否固定元素
		const router = useRouter();  // 获取 Vue Router 实例
		
		
		const handleScroll = () => {
			if (scrollContainer.value.scrollTop > 0) {
				isFixed.value = true;  // 向下滚动时固定元素
			} else {
				isFixed.value = false;  // 当页面回到顶部时移除固定
			}
		};
		
		const goToSearch = () => {
			router.push('/SearchMiddle');
		};
	
	

	return {
		isFixed,
		scrollContainer,
		handleScroll,
		goToSearch
	};
  }
}
</script>

<style>
</style>